module.exports = __webpack_public_path__ + "static_portal/img/man-rowing-small.ab312a62.jpg";